module.exports = __webpack_public_path__ + "img/logo-header.635781f7.png";